import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import intl from 'react-intl-universal';
import { registerLanguage } from './i18n';

import { isMobile as mobileCheck } from '../../utils/is';
import BaseRoute from './Route';
import { registerSlardar } from '@src/utils/slardar';
import { questionnaireInitToken } from '@src/utils/tea';
import { IsMobileCtx } from './context/isMobile';

import './index.less';

registerSlardar();

const App = () => {
    const isMobile = useMemo(() => {
        return mobileCheck();
    }, []);

    useEffect(() => {
        isMobile && document.documentElement.classList.add('isMobile');
        !isMobile && document.documentElement.classList.add('isPc');
        document.title = intl.get('title');
    }, [isMobile]);

    return (
        <ConfigProvider autoInsertSpaceInButton={false}>
            <IsMobileCtx.Provider value={{ isMobile }}>
                <BaseRoute isMobile={isMobile}></BaseRoute>
            </IsMobileCtx.Provider>
        </ConfigProvider>
    );
};

const render = async () => {
    // 注册语言
    await registerLanguage();
    questionnaireInitToken({});

    ReactDOM.render(<App />, document.getElementById('root'));
};

render();
